import {
  MineModelDto,
  ProjectDto,
  RheologyDataDto,
  useMineModelQuery,
  useProjectQuery,
  useRheologyDataQuery
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { HOUR_IN_MILLISECONDS } from 'config';
import { EditRheologyPageParams } from './constants';

export type EditRheologyQueries = [
  UseQueryResult<RheologyDataDto | undefined>,
  UseQueryResult<ProjectDto, unknown>,
  UseQueryResult<MineModelDto | undefined>
];

const useEditRheologyQueries = (params: EditRheologyPageParams): EditRheologyQueries => {
  const rheologyQuery = useRheologyDataQuery(
    {
      mineModelId: params.entityId,
      rheologyDatasetId: params.rheologyId,
    },
  );

  const projectQuery = useProjectQuery(params.entityId, {
    staleTime: HOUR_IN_MILLISECONDS,
  });

  const mineModelQuery = useMineModelQuery({ mineModelId: params.entityId }, {
    staleTime: HOUR_IN_MILLISECONDS,
  });

  return [rheologyQuery, projectQuery, mineModelQuery];
};

export default useEditRheologyQueries;
